export { positionElements, Positioning } from './ng-positioning'
export { PositioningService, PositioningOptions } from './positioning.service';



// WEBPACK FOOTER //
// ./src/app/angular-bootstrap-md/utils/positioning/index.ts